import { useEffect } from 'react';
import { CopilotOutput } from 'libs/end-to-end/src/copilot';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const useBasicCopilotPrefillSubjectIdsEffect = ({
  copilotData,
  setSelectedSlateIds,
  subjectIdsToPrefill,
}: {
  copilotData: CopilotOutput | null;
  setSelectedSlateIds: Setter<string[]>;
  subjectIdsToPrefill: string[];
}) => {
  useEffect(() => {
    if (!copilotData) {
      return;
    }

    setSelectedSlateIds(subjectIdsToPrefill);
  }, [copilotData, subjectIdsToPrefill, setSelectedSlateIds]);
};
